import React, { useState } from "react";
import { TextField } from "@mui/material";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import ConstantData from "../../../Utils/Constant";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";
function CreateUser(props) {
  const steps = ["Basic User Details", "Select Subscription", "Review"];
  const [activeStep, setActiveStep] = useState(0);
  const [payment, setPayment] = useState(null);
  const [show, setShow] = useState(false);
  const [packagetype, setPackagetype] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [firstNameErr, setFirstNameErr] = useState("");
  const [lastNameErr, setLastNameErr] = useState("");
  const [phoneErr, setPhoneErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [subscriptionidErr, setSubscriptionidErr] = useState("");
  const [packagedetails, setPackagedetails] = useState([]);
  const [packageErr, setPackageErr] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [UserDetails, setUserDetails] = useState({
    firstname: "",
    lastname: "",
    company: null,
    phone: "",
    emailaddress: "",
  });
  const [load, setLoad] = useState([]);
  const packs = (props?.userpack || [])
  .filter(val => 
    val.subscriptionname === "Free Explorer" ||
    (val.subscriptionname === "Pro Subscription" && val.price > 0)
  )
  .map(val => ({
    ...val,
    name: val.subscriptionname === "Free Explorer" ? "Free" : val.subscriptionname
  }))
  .sort((a, b) => {
    if (a.subscriptionname === "Free Explorer") return -1;
    if (b.subscriptionname === "Free Explorer") return 1;
    return -1;
  });
  const [modeofsubscriptionid, setModeofubscriptionid] = useState();
  const [subscriptionid, setSubscriptionid] = useState();
  const navigate = useNavigate();
  const handlenext = () => {
    let isValid = false;
    let isid = false;
     if (packagetype === "Pro Subscription" && payment == 3) {
      if (!modeofsubscriptionid) {
        setSubscriptionidErr("Subscription ID is required");
        isid = true;
      }
      if (isid) return;
    }
    setLoading(true);

    setLoading(false);
    if (activeStep == 1) {
      if (!packagetype) {
        setPackageErr("Choose alteast one package");
      }
      if (packagetype == "Free") {
        setActiveStep((prev) => {
          const check = prev + 1;
          if (check === 2) {
            setLoad([UserDetails]);
          }
          return check;
        });
      }
      if (packagetype === "Pro Subscription") {
        setActiveStep((prev) => {
          const check = prev + 1;
          if (check === 2) {
            setLoad([UserDetails]);
          }
          return check;
        });
      }
    }
    
    if (activeStep === 0) {
      if (!UserDetails.firstname) {
        setFirstNameErr("First Name is required");
        isValid = true;
      }
      if (!UserDetails.lastname) {
        setLastNameErr("Last Name is required");
        isValid = true;
      }
      if (!UserDetails.emailaddress) {
        setEmailErr("Email Address is required");
        isValid = true;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          UserDetails.emailaddress
        )
      ) {
        setEmailErr("Invalid email format");
        isValid = true;
      }
      if (!UserDetails.phone) {
        setPhoneErr("Phone Number is required");
        isValid = true;
      }
      if(firstNameErr||lastNameErr||emailErr||phoneErr){
        isValid=true
      }
      if (isValid) return;
   
      apiCommonTrigger("get",Config.API_URL + "/home/validatesignupemail/" , [UserDetails.emailaddress])
        .then((res) => {
          setLoading(false);
          if (res.status === 200) {
            if (res.data.isexist) {
              setEmailErr(
                "Email already linked to an existing RV Parks account. Please use a different email address."
              );
              return; 
            }
          } else {
            handlingCatchError(res);
            return;
          }
          setActiveStep((prev) => {
            const check = prev + 1;
            if (check === 2) {
              setLoad([UserDetails]);
            }
            return check;
          });
        })
        .catch((error) => {
          setLoading(false);
          handlingCatchError(error);
        });
    }
    
  };

  const handlePackClick = (pack) => {
    setSubscriptionid(pack.id);
    if (pack.name !== "Free") {
      setPayment(2);
      setPackagedetails(
        `${pack.currency} ${pack.price} / ${pack.description}`
      );
    }
    else {
      setPayment(null);
    }
    setPackagetype((prev) => {
      if (pack.name === "Pro Subscription" && pack.name !== prev) {
        setShow(true);
      }
      return pack.name;
    });
  }
  const NumberFormat = (number) => {
    return new Intl.NumberFormat().format(number);
    }
  const handleback = () => {
    setActiveStep((prev) => prev - 1);
  };
  let SubscriptionDetails = [
    {
      modeofsubscription: payment,
      subscriptionid: subscriptionid,
      ...(payment === 3 && {
        payment: { subscriptionid: modeofsubscriptionid },
      }),
    },
  ];
  const submit = () => {
    let inputData={UserDetails: UserDetails,
        SubscriptionDetails: SubscriptionDetails}
    apiCommonTrigger("post",`${Config.API_URL}/admin/adduser`,inputData)
      .then((res) => {
        if (res.status === 200) {
          setAlertMessage(true);
          setSeverity("success");
          setMessage("User created Successfully");
          setLoading(false);
          setTimeout(() => {
            setAlertMessage(false);
            props.onClose();
            props.fetchdata();
          }, 2000);
        } else {
          
          handlingCatchError(res, navigate);
        }
        setLoading(false);
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
        setLoading(false);
       
      });
  };
  return (
    <>
      <div className="create-user-step">
        <Stepper style={{width:'10%'}} activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div className="stepper-fields">
          {activeStep == 0 ? (
            <>
              <div className="d-flex gap-3">
                <TextField
                  label={<>First Name <span style={{color:firstNameErr?"red":"black"}}>*</span></>}
                  name="firstname"
                  type="text"
                  value={UserDetails ? UserDetails.firstname : ""}
                  onChange={(e) => {
                    const { value } = e.target;
                    setUserDetails((prevData) => ({
                      ...prevData,
                      firstname: value,
                    }));

                    if (!value) {
                      setFirstNameErr("First Name is required");
                    } else if (value.length < 3 || value.length > 16) {
                      setFirstNameErr(
                        "First Name must be between 3 and 30 characters."
                      );
                    } else if (value.match(/[!@#$%^&*(),.?";:{}|<>=\+\[\]\-\/\\]/g)) {
                        setFirstNameErr("Invalid Character");
                    } else {
                      setFirstNameErr("");
                    }
                  }}
                  error={!!firstNameErr}
                  helperText={firstNameErr}
                  className="w-100 textbox-custom"
                />
                <TextField
                  label={<>Last Name <span style={{color:lastNameErr?"red":"black"}}>*</span></>}
                  name="lastname"
                  type="text"
                  value={UserDetails ? UserDetails.lastname : null}
                  onChange={(e) => {
                    const { value } = e.target;
                    setUserDetails((prevData) => ({
                      ...prevData,
                      lastname: value,
                    }));
                    if (!value) {
                      setLastNameErr("Last Name is required");
                    } else if (value.length < 3 || value.length > 16) {
                      setLastNameErr(
                        "Last Name must be between 3 and 30 characters."
                      );
                    } else if (value.match(/[!@#$%^&*(),.?";:{}|<>=\+\[\]\-\/\\]/)) {
                        setLastNameErr("Invalid Character");
                    } else {
                      setLastNameErr("");
                    }
                  }}
                  error={!!lastNameErr}
                  helperText={lastNameErr}
                  className="w-100 textbox-custom"
                ></TextField>
              </div>
              <div className="d-flex gap-3 mt-4">
                <TextField
                  label="Company"
                  name="company"
                  type="text"
                  value={UserDetails ? UserDetails.company : null}
                  onChange={(e) => {
                    const { value } = e.target;
                    setUserDetails((prevData) => ({
                      ...prevData,
                      company:value?value:null,
                    }));
                    }}
                  className="w-100 textbox-custom"
                ></TextField>

                <TextField
                  label={<>Phone Number <span style={{color:phoneErr?"red":"black"}}>*</span></>}
                  name="phone"
                  type="tel"
                  value={UserDetails.phone || ""}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    setUserDetails((prevData) => ({
                      ...prevData,
                      phone: value,
                    }));

                    if (!value) {
                      setPhoneErr("Phone Number is required");
                    } else if (value.length > 15) {
                      setPhoneErr("Invalid number");
                    } else if (!/^([0-9]*)$/.test(value)) {
                      setPhoneErr("Invalid number");
                    } else {
                      setPhoneErr("");
                    }

                    if (value.length >= 10) {
                      let formatted = `(${value.substring(
                        0,
                        3
                      )}) ${value.substring(3, 6)}-${value.substring(6)}`;
                      setUserDetails((prevData) => ({
                        ...prevData,
                        phone: formatted,
                      }));
                    }
                  }}
                  error={!!phoneErr}
                  helperText={phoneErr}
                  className="w-100 textbox-custom"
                  onKeyDown={(e) => {
                    if (!/^\d+$/.test(e.key) && !["Backspace", "Tab"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="mt-4">
                <TextField
                  label={<>Email Address <span style={{color:emailErr?"red":"black"}}>*</span></>}
                  name="emailaddress"
                  type="email"
                  value={UserDetails.emailaddress.trim() || ""}
                  onChange={(e) => {
                    let value = e.target.value;
                    setUserDetails((prevData) => ({
                      ...prevData,
                      emailaddress: value,
                    }));

                    if (!value.trim()) {
                      setEmailErr("Email Address is required");
                    } else if (
                      !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(
                        value
                      )
                    ) {
                      setEmailErr("Invalid email format");
                    } else {
                      setEmailErr("");
                    }
                  }}
                
                  error={!!emailErr}
                  helperText={emailErr}
                  className="w-100 textbox-custom"
                />
              </div>
            </>
          ) : null}
          {activeStep === 1 && (
            <>
              <h5>Select Package</h5>
              <div className="d-flex" style={{ gap: "30px" }}>
                {packs?.map((pack,ind) => (
                  <button
                    className="package-btn"
                    key={ind}
                    onClick={() => handlePackClick(pack)}
                    style={{
                      backgroundColor:
                        subscriptionid === pack.id ? "#01890a" : "#fff",
                      color: subscriptionid === pack.id ? "#fff" : "#73738c",
                    }}
                  >
                    {pack.name} 
                    {pack.name === "Pro Subscription" ? (
                    <p
                      onClick={() => {
                        setPackagedetails(
                          `${pack.currency} ${pack.price} / ${pack.description}`
                        );
                        setSubscriptionid(pack.id);
                      }}
                      className="val_price"
                    >
                      {pack.id !== 7 && (
                        <b>
                          {pack?.currency}
                          {NumberFormat(pack?.price)}
                        </b>
                      )}
                      <span>{pack?.description}</span>
                    </p>
                  ) : ""}
                  </button>
                ))}
              </div>
              {!packagetype ? (
                <p
                  style={{
                    color: "#f15d47",
                    marginTop: "5px",
                    fontSize: "12px",
                  }}
                >
                  {packageErr}
                </p>
              ) : (
                ""
              )}

              {show && packagetype === "Pro Subscription" && (
                <div className="mt-4">
                  <h5 style={{ marginBottom: "10px" }}>Select Payments</h5>
                  <div className="payment-options">
                    {ConstantData.paymenttype?.filter((val) => subscriptionid !== 7 || val.id !== 1)
                      ?.map((val, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Radio
                            name="payment"
                            value={val.id}
                            onChange={() => setPayment(val.id)}
                            checked={payment === val.id}
                          />
                        }
                        label={val.name}
                      />
                    ))}
                    {payment === 3 ? (
                      <TextField
                        label="Subscription ID *"
                        type="text"
                        value={modeofsubscriptionid}
                        error={!!subscriptionidErr}
                        helperText={subscriptionidErr}
                        onChange={(e) => {
                          const { value } = e.target;
                          setModeofubscriptionid(value);

                          if (!value) {
                            setSubscriptionidErr("Subscriptionid is required");
                          } else {
                            setSubscriptionidErr("");
                          }
                        }}
                        className="textbox-custom"
                      />
                    ) : null}
                  </div>
                </div>
              )}
            </>
          )}

          {activeStep === 2 && (
            <>
              <div className="container">
                {load && load.length > 0
                  ? load.map((val, index) => (
                      <div key={index}>
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="rounded-circle  text-white d-flex justify-content-center align-items-center"
                            style={{
                              width: "24px",
                              height: "24px",
                              fontSize: "16px",
                              backgroundColor: "#2e7d32",
                            }}
                          >
                            1
                          </div>
                          <h5 className="ms-2 mb-0 fw-bold">
                            Basic User Details
                          </h5>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <p className="label-name mb-1">First Name:</p>
                            <p className="mb-2 label-values">{val.firstname}</p>
                            <p className="label-name mb-1">Phone:</p>
                            <p className="mb-2 label-values">{val.phone}</p>
                          </div>
                          <div className="col-md-6">
                            <p className="label-name mb-1">Last Name:</p>
                            <p className="mb-2 label-values">{val.lastname}</p>
                            <p className="label-name mb-1">Email Address:</p>
                            <p className="mb-2 label-values">
                              {val.emailaddress}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}

                <div className="final-step">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="rounded-circle  text-white d-flex justify-content-center align-items-center"
                      style={{
                        width: "24px",
                        height: "24px",
                        fontSize: "16px",
                        backgroundColor: "#2e7d32",
                      }}
                    >
                      2
                    </div>
                    <h5 className="ms-2 mb-0 fw-bold">Selected Package</h5>
                  </div>
                  <div className="card p-3 shadow-sm bg-light">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="label-name mb-1">Product Name</p>
                        <p className="mb-2 label-values">RVParkIQ</p>
                      </div>
                      <div className="col-md-6">
                        <p className="label-name mb-1">Selected Subscription</p>
                        <p className="mb-2 label-values">{packagetype}</p>
                      </div>
                      <div className="col-md-6">
                        {packagetype === "Pro Subscription" && (
                          <>
                            <p className="label-name mb-1">
                              Selected Package Details:
                            </p>
                            <p className="mb-1 label-values">
                              Subscription for <b>
                                <b> </b>
                                {packagedetails}
                                </b>
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="bottom-btn">
        {activeStep > 0 && (
          <Button onClick={handleback} variant="outlined" className="back-btn">
            Back
          </Button>
        )}
        {activeStep < steps.length - 1 ? (
          <Button
            onClick={handlenext}
            variant="contained"
            color="primary"
            className="next-create-btn"
          >
            Next
          </Button>
        ) : (
          <Button
            variant="contained"
            color="success"
            onClick={submit}
            className="finish-btn"
          >
            Create
          </Button>
        )}
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alertMessage}
      >
        <Alert severity={severity} variant="filled">
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
export default CreateUser;
